import { finalize } from 'rxjs/operators';
import { AGENT_FEATURE, AI_SMART_COMPARE_FEATURE, } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { QuickflowsService } from 'QuickflowsApp/ts/services/quickflows.service';
import { IconSearchAutocompleteComponent } from 'SearchApp/ts/features/icon-search-autocomplete/icon-search-autocomplete.component';
import * as i0 from "@angular/core";
import * as i1 from "QuickflowsApp/ts/services/quickflows.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = () => ["popover"];
function MultiSelectQuickflowsComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "a", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵlistener("click", function MultiSelectQuickflowsComponent_div_5_div_1_Template_div_click_4_listener() { const index_r2 = i0.ɵɵrestoreView(_r1).index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.deleteItem(index_r2)); });
    i0.ɵɵelementStart(5, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 14);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipPlacement", "left")("tooltipTitle", item_r4.securityName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", i0.ɵɵinterpolate(item_r4.securityUrl), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4.displaySecurityId, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close-circle");
} }
function MultiSelectQuickflowsComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, MultiSelectQuickflowsComponent_div_5_div_1_Template, 7, 6, "div", 9);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, ctx_r2.items, 0, 12));
} }
function MultiSelectQuickflowsComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function MultiSelectQuickflowsComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.handleSmartCompareClick()); });
    i0.ɵɵtext(1, " Smart Compare ");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-sparkle");
} }
function MultiSelectQuickflowsComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "span");
    i0.ɵɵtext(3, "Add at least 2 securities");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "to view Quickflow Comparisons");
    i0.ɵɵelementEnd()()();
} }
function MultiSelectQuickflowsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "span");
    i0.ɵɵtext(3, "There are no quickflows available for");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5, "the current assortment of securities");
    i0.ɵɵelementEnd()()();
} }
function MultiSelectQuickflowsComponent_ng_container_9_div_1_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const quickflow_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("tooltipClasses", i0.ɵɵpureFunction0(3, _c0))("tooltipTitle", quickflow_r7["tooltip_text"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-info");
} }
function MultiSelectQuickflowsComponent_ng_container_9_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "a", 23)(2, "span", 24);
    i0.ɵɵlistener("click", function MultiSelectQuickflowsComponent_ng_container_9_div_1_div_3_Template_span_click_2_listener() { const quickflow_r7 = i0.ɵɵrestoreView(_r6).$implicit; const ctx_r2 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r2.select(quickflow_r7["id"])); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MultiSelectQuickflowsComponent_ng_container_9_div_1_div_3_div_3_Template, 2, 4, "div", 25);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const quickflow_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", quickflow_r7["label"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", quickflow_r7["tooltip_text"]);
} }
function MultiSelectQuickflowsComponent_ng_container_9_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "div", 20);
    i0.ɵɵelementStart(2, "div", 21);
    i0.ɵɵtemplate(3, MultiSelectQuickflowsComponent_ng_container_9_div_1_div_3_Template, 4, 2, "div", 22);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const quickflows_grouped_by_app_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", quickflows_grouped_by_app_r8["app_name"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", quickflows_grouped_by_app_r8["quickflows"]);
} }
function MultiSelectQuickflowsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MultiSelectQuickflowsComponent_ng_container_9_div_1_Template, 4, 2, "div", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.availableQuickflows);
} }
function MultiSelectQuickflowsComponent_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 27);
    i0.ɵɵelement(2, "div", 28)(3, "div", 29)(4, "div", 30)(5, "div", 31);
    i0.ɵɵelementEnd()();
} }
function MultiSelectQuickflowsComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MultiSelectQuickflowsComponent_ng_container_10_div_1_Template, 6, 0, "div", 19);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.availableQuickflows);
} }
/**
 *
 * Multi Select Quickflows Component
 *
 * This component is one tab of the quickflows menu.
 *
 * Input Properties:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *
 */
export class MultiSelectQuickflowsComponent {
    constructor(quickflowsService, featureService) {
        this.quickflowsService = quickflowsService;
        this.featureService = featureService;
        this.availableQuickflows = [];
        this.hasSmartCompareFeature = false;
        this.loadingCollection = false;
        this.items = [];
    }
    ngOnInit() {
        this.hasSmartCompareFeature = this.featureService.userHasFeatures([AI_SMART_COMPARE_FEATURE]);
        this.quickflowsService.getMultiSecurityQuickflowsList().subscribe((data) => {
            const { securityIds } = data;
            if (securityIds && securityIds.length > 0) {
                this.items = securityIds;
                this.refreshQuickflowCollection();
            }
            else if (this.securityId && this.displaySecurityId && this.securityName && this.securityUrl) {
                this.addItem({
                    display_security_id: this.displaySecurityId,
                    search_id: this.securityId,
                    name: this.securityName,
                    url: this.securityUrl,
                }, false);
            }
        });
    }
    select(quickflowId) {
        this.quickflowRedirect(quickflowId);
    }
    /**
     * Adds a security to the list of comparison quickflows securities.
     * @param securityObject security to add
     * @param save whether to save the updated list of securities to the database.
     * This will be false if we are adding the current page security and not one chosen by the user, because
     * we want to add the current page security any time they switch to a different quote page unless they
     * have added different securities from the autocompleter.
     */
    addItem(securityObject, save = true) {
        const MAX_ITEMS = 12;
        // do nothing if the securityId is already part of the items list
        for (let i = 0; i < this.items.length; i += 1) {
            if (this.items[i].securityId === securityObject.search_id)
                return;
        }
        if (this.items.length === MAX_ITEMS)
            return;
        // autocompleter uses `search_id` which is essentially a security's `securityId`
        this.items.push({
            displaySecurityId: securityObject.display_security_id,
            securityId: securityObject.search_id,
            securityName: securityObject.name,
            securityUrl: securityObject.url,
        });
        // snapshot the current list of securities & update
        if (save) {
            this.updateQuickflowsList();
        }
        this.refreshQuickflowCollection();
    }
    deleteItem(index) {
        this.items.splice(index, 1);
        // snapshot the current list of securities & update
        this.updateQuickflowsList();
        this.refreshQuickflowCollection();
    }
    quickflowRedirect(quickflowId) {
        const securityIds = this.getSecurityIds();
        this.quickflowsService.getMultiSecurityQuickflowsRedirect(quickflowId, securityIds).subscribe((data) => {
            const quickflowURL = new URL(data.url);
            // Change the browser URL to the quickflows URL.
            window.location.assign(quickflowURL.href);
            // If the path of the application is not changing we need to set the
            // url state and reload so that the application loads from scratch.
            if (quickflowURL.pathname === window.location.pathname) {
                window.location.reload();
            }
        });
    }
    updateQuickflowsList() {
        const securityIds = this.getSecurityIds();
        this.quickflowsService.putMultiSecurityQuickflowsList(securityIds).subscribe({
            next: () => { },
            error: (error) => {
                // If user is logged out, PUT will fail with 403 or 405. Re-raise any other errors
                if (error.status !== 403 && error.status !== 405) {
                    throw error;
                }
            },
        });
    }
    refreshQuickflowCollection() {
        // only update the quickflow collection if there are at least 2 securities selected
        if (this.items.length > 1) {
            this.updateQuickflowCollection();
        }
        this.focusAutocompleter();
    }
    updateQuickflowCollection() {
        this.loadingCollection = true;
        const securityIds = this.getSecurityIds();
        this.quickflowsService
            .getMultiSecurityQuickflowsCollection(securityIds)
            .pipe(finalize(() => {
            this.loadingCollection = false;
        }))
            .subscribe({
            next: (data) => {
                this.availableQuickflows = data.filter((quickflowsByApp) => quickflowsByApp.quickflows.length > 0);
            },
            error: () => {
                this.availableQuickflows = [];
            },
        });
    }
    getSecurityIds() {
        const securityIds = this.items.map(({ securityId }) => securityId);
        return securityIds.join(',');
    }
    focusAutocompleter() {
        if (this.autocompleteComponent) {
            this.autocompleteComponent.focus();
        }
    }
    handleSmartCompareClick() {
        const smartCompareIds = this.items.map((item) => item.securityId);
        const prompt = this.buildSmartComparePrompt(smartCompareIds);
        const queryParams = new URLSearchParams({
            smartComparePrompt: prompt,
            smartCompareIds: smartCompareIds.join(','),
        });
        // TODO: When AI_CHAT_FEATURE is removed, this should always redirect to the agent
        const hasAgentFeature = window.USER?.features?.includes(AGENT_FEATURE) ?? false;
        const basePath = hasAgentFeature ? '/agent/#/' : '/ai_chat/#/';
        window.location.href = `${basePath}?${queryParams.toString()}`;
    }
    buildSmartComparePrompt(ids) {
        if (ids.length === 1)
            return `Smart Compare ${ids[0]}`;
        if (ids.length === 2)
            return `Smart Compare ${ids[0]} and ${ids[1]}`;
        return `Smart Compare ${ids.slice(0, -1).join(', ')} and ${ids[ids.length - 1]}`;
    }
}
MultiSelectQuickflowsComponent.ɵfac = function MultiSelectQuickflowsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultiSelectQuickflowsComponent)(i0.ɵɵdirectiveInject(i1.QuickflowsService), i0.ɵɵdirectiveInject(i2.FeatureService)); };
MultiSelectQuickflowsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiSelectQuickflowsComponent, selectors: [["ycn-multi-select-quickflows"]], viewQuery: function MultiSelectQuickflowsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(IconSearchAutocompleteComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteComponent = _t.first);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl" }, standalone: false, decls: 11, vars: 8, consts: [[1, "quickflows-section", 2, "padding-bottom", "10px"], [1, "quickflows-section-header"], [3, "submitHandler", "appendToBody", "searchType"], [1, "feedback"], ["class", "quickflows-labels-list", 4, "ngIf"], ["class", "btn btn-outline btn-secondary", "style", "width: 100%", "data-test-id", "quickflows-smart-compare-button", 3, "click", 4, "ngIf"], ["class", "quickflows-section", 4, "ngIf"], [4, "ngIf"], [1, "quickflows-labels-list"], ["class", "btn btn-purple-tint", "data-test-id", "quickflows-comparison-security", 4, "ngFor", "ngForOf"], ["data-test-id", "quickflows-comparison-security", 1, "btn", "btn-purple-tint"], ["ycnTooltip", "", 3, "tooltipPlacement", "tooltipTitle"], [3, "href"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"], ["data-test-id", "quickflows-smart-compare-button", 1, "btn", "btn-outline", "btn-secondary", 2, "width", "100%", 3, "click"], ["ycnIcon", "", 2, "margin-left", "4px", "margin-bottom", "4px", 3, "name"], [1, "quickflows-section"], [1, "get-started-small"], ["class", "quickflows-section", 4, "ngFor", "ngForOf"], [1, "quickflows-section-title", 3, "textContent"], [1, "quickflows-list"], [4, "ngFor", "ngForOf"], ["href", "javascript:void(0)", 1, "quickflows-list-item"], [3, "click", "textContent"], ["class", "btn btn-xs btn-circle btn-transparent btn-i", "ycnTooltip", "", 3, "tooltipClasses", "tooltipTitle", 4, "ngIf"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-i", 3, "tooltipClasses", "tooltipTitle"], [1, "quickflows-list", "options-list-skeleton"], [1, "skeleton", 2, "width", "88%"], [1, "skeleton", 2, "width", "40%"], [1, "skeleton", 2, "width", "15%"], [1, "skeleton", 2, "width", "65%"]], template: function MultiSelectQuickflowsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "ycn-icon-search-autocomplete", 2);
        i0.ɵɵlistener("submitHandler", function MultiSelectQuickflowsComponent_Template_ycn_icon_search_autocomplete_submitHandler_2_listener($event) { return ctx.addItem($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "Compare 2 to 12 securities.");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, MultiSelectQuickflowsComponent_div_5_Template, 3, 5, "div", 4)(6, MultiSelectQuickflowsComponent_button_6_Template, 3, 1, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, MultiSelectQuickflowsComponent_div_7_Template, 6, 0, "div", 6)(8, MultiSelectQuickflowsComponent_div_8_Template, 6, 0, "div", 6)(9, MultiSelectQuickflowsComponent_ng_container_9_Template, 2, 1, "ng-container", 7)(10, MultiSelectQuickflowsComponent_ng_container_10_Template, 2, 1, "ng-container", 7);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("appendToBody", true)("searchType", "quickflow_securities");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.items.length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.items.length > 1 && ctx.hasSmartCompareFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.items.length < 2 && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.items.length >= 2 && ctx.availableQuickflows.length == 0 && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.items.length >= 2 && !ctx.loadingCollection);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loadingCollection);
    } }, dependencies: [i3.NgForOf, i3.NgIf, i4.IconDirective, i5.IconSearchAutocompleteComponent, i6.TooltipDirective, i3.SlicePipe], encapsulation: 2 });
